<template>
	<popup-modal ref="popup">
		<v-card>
			<v-toolbar color="primary" dark>
				{{ form.subject }}
			</v-toolbar>

			<v-card-text class="mt-4">
				<p>{{ form.number }} от {{ form.date }}</p>
				<form>
					<v-text-field label="Локация" prepend-icon="mdi-map-marker-outline" v-model="form.location" readonly></v-text-field>

					<v-text-field label="Статус" prepend-icon="mdi-text-box-search" v-model="form.status" readonly></v-text-field>

					<v-textarea label="Сообщение" v-model="form.comment" prepend-icon="mdi-comment-outline" readonly></v-textarea>

					<v-btn text color="primary" @click="downloadFile(file)" v-for="file in form.files" :key="file.fileGUID">
						<v-icon dark> mdi-download </v-icon>
						{{ file.fileName }}</v-btn
					>
				</form>
			</v-card-text>

			<!--                Actions-->
			<v-card-actions>
				<div v-if="acceptMessageVisible">
					<v-btn @click="Positive('Подтвержден')" color="primary" class="mr-2">{{ $t("common.button_accept") }}</v-btn>
					<v-btn @click="Positive('Отказ')" color="error">{{ $t("common.button_reject") }}</v-btn>
				</div>

				<v-btn @click="openUrl(form.linkURL)" text v-if="form.linkURL !== ''">{{ form.linkTitle }}</v-btn>

				<div class="flex-grow-1"></div>
				<v-btn @click="Negative" text>{{ $t("common.button_close") }}</v-btn>
				<!--        <v-btn @click="Positive" color="primary">{{ $t('common.button_ok') }}</v-btn>-->
			</v-card-actions>
		</v-card>
	</popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal"
import { mapActions } from "vuex"
// eslint-disable-next-line
import { downloadBase64File, fileToBase64, selectFile } from "@/domain/utils"

export default {
	name: "DialogEditTicket",
	components: { PopupModal },
	data: () => ({
		inputData: { title: "" },

		form: {
			number: "",
			date: "",
			location: "",
			status: "",
			files: [],
			comment: "",
		},

		// Private variables
		resolvePromise: undefined,
		rejectPromise: undefined,
	}),
	methods: {
		...mapActions("app", ["apiGetFile", "apiMessageRead"]),

		async downloadFile(file) {
			console.log("downloadFile")
			await this.apiGetFile({ fileGUID: file.fileGUID, fileMetatype: file.fileMetatype })
		},

		show(opts = {}) {
			console.log(opts)
			this.form = opts

			console.log("this.form", this.form)

			// Once we set our config, we tell the popup modal to open
			this.$refs.popup.open(false, true)

			if (!opts.readStatus) {
				//Если сообщение значилось как непрочтенное то отправим уведомление о прочтении
				this.apiMessageRead({ GUID: opts.GUID })
			}

			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		openUrl(href) {
			var link = document.createElement("a")
			link.href = href
			link.click()
		},

		Positive(status) {
			this.$refs.popup.close()
			this.resolvePromise({ answer: "positive", form: this.form, status: status })
		},
		Negative() {
			this.$refs.popup.close()
			this.resolvePromise({ answer: "negative" })
		},
	},
	computed: {
		acceptMessageVisible() {
			return this.form.messageType === "Биллинг" && this.form.status === "Новый"
		},
	},
}
</script>
